import React, {Component} from 'react';
import {Form, Modal, Button,message,Input} from 'antd';	
import { connect } from 'react-redux';
import moment from 'moment';

import API from '@/API/api';
import {createCategoryLabelAPI} from '@/API';
const FormItem = Form.Item;


const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 14 },
  },
};

class CreateLabelModal extends Component{
	
	static contextTypes={
	    router: React.PropTypes.object.isRequired,
	}
	constructor(props) {
	    super(props);
	    this.state={
			btnLoading:false
		}

    }
	componentDidMount(){
		
	}

	handleSubmit = (e) => {
	    e.preventDefault();
	    this.props.form.validateFieldsAndScroll((err, values) => {
	      if (!err) {
	        this.setState({btnLoading:true})
	        let postForm={
	        		"type":this.props.cateitemType,
	        		"cateitem":values.label
	        }
			createCategoryLabelAPI(postForm).then(res=>{
				message.success('保存成功！');
		      	this.setState({btnLoading:false})
		      	this.props.handleClose()
		      	this.props.form.resetFields();
			})
           
	      }
	    });
	 }


	
	render(){
		let {btnLoading}=this.state
		let {openCreate,handleClose}=this.props
		const { getFieldDecorator } = this.props.form;
		const filedOption={
			input:{rules: [{ type: 'string',required: true,max:15, message: '必填且至多15个字符!', whitespace: true }]}
		}
		
		return(
			<Modal
	          title="添加标签"
	          visible={openCreate}
	          onCancel={handleClose}
	          footer={[
	            <Button key="cancel"  onClick={handleClose}>取消</Button>,
	            <Button key="save" type="primary"  loading={btnLoading} onClick={this.handleSubmit}>添加</Button>,
	          ]}
	        >
				<Form >
					<FormItem {...formItemLayout} label="标签名" hasFeedback>
						{getFieldDecorator(`label`, filedOption.input)(<Input /> )}
					</FormItem>
				</Form >
			 </Modal>
		)
	}
}


export const WrappedCreateLabelModalForm = Form.create()(CreateLabelModal)



// WEBPACK FOOTER //
// ./src/entry_app/knowledge_assist/wordBank/modal/create_label.js